module.exports = __webpack_public_path__ + "img/difficultyLevel_4.e1d008df.svg";